<template>
  <div>
    <vs-navbar square center-collapsed shadow>
      <!-- <template #left>
        <vs-button @click="activeSidebar = !activeSidebar" border icon>
          <i class="bx bx-menu"></i>
        </vs-button>
      </template> -->
      <vs-navbar-item class="solid">
        <img
          src="https://www.kuntokruunu.fi/wp-content/uploads/2020/07/LOGO.png"
          alt="logo"
        />
      </vs-navbar-item>
    </vs-navbar>

    <!-- <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> -->

    <!-- <vs-sidebar :open.sync="activeSidebar">
      <template #logo>
        <img
          src="https://www.kuntokruunu.fi/wp-content/uploads/2020/07/LOGO.png"
          alt="logo"
        />
      </template>
      <vs-sidebar-item id="home" href="https://www.kuntokruunu.fi">
        <template #icon>
          <i class="bx bx-home"></i>
        </template>
        KuntoKruunun etusivu
      </vs-sidebar-item>

      <div>
        <vs-select
          placeholder="Select"
          v-model="selectedClubId"
          label="Kuntokeskus"
        >
          <vs-option
            v-for="club in allClubs"
            :key="club.id"
            label="club.name"
            value="club.id"
          >
            {{ club.name }}
          </vs-option>
        </vs-select>
      </div>

      <template #footer>
        <vs-row justify="space-between">
          <vs-switch @input="setTheme" v-model="darkMode">
            <template #circle>
              <i v-if="!darkMode" class="bx bxs-sun"></i>
              <i v-else class="bx bxs-moon"></i>
            </template>
          </vs-switch>
        </vs-row>
      </template>
    </vs-sidebar> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NavBar",
  data: () => ({
    activeSidebar: false,
    darkMode: ""
  }),
  computed: mapGetters(["allClubs", "getSelectedClub"]),
  methods: {
    setTheme() {
      if (this.darkMode)
        document
          .getElementsByTagName("BODY")[0]
          .setAttribute("vs-theme", "dark");
      if (!this.darkMode)
        document.getElementsByTagName("BODY")[0].setAttribute("vs-theme", "");
    }
  },
  created() {
    const userPrefersDark =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;

    if (userPrefersDark) this.darkMode = true;
    else this.darkMode = false;
    this.setTheme();
  }
};
</script>

<style scoped>
img {
  max-height: 70px;
}
.solid {
  opacity: 1;
}
</style>
